import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  className = 'QuestionnaireService';

  constructor(private http: HttpClient, private router: Router) { }

  getAllQuestionnaires(questionnaireTypeIds = null): any {
    let params: any = {};
    if (questionnaireTypeIds) {
      params.questionnaireTypeIds = questionnaireTypeIds;
    }

    return this.http.get(environment.base_URL + "/questionnaires", { params }).pipe(map(res => {
      return _.map(res, (q: any) => {
        let totalValoration = 0;
        let totalNumerableQuestions = 0;
        _.forEach(q.evaluations, (e) => {
          let question = _.get(e, 'questionnaireQuestion.question');
          let isNumerable = _.get(question, 'optionQuestion');
          let valoration = _.get(e, 'mumEvaluationValue', 0);
          if (isNumerable) {
            totalNumerableQuestions++;
            totalValoration += valoration;
          }
        })
        q.evaluations = _.sortBy(q.evaluations, (e) => {
          return _.get(e, 'questionnaireQuestion.nmrOrder');
        });
        q.valoration = totalNumerableQuestions ? (totalValoration / totalNumerableQuestions).toFixed(2) : 0;
        return q;
      })
    }));
  }

  getIsRead() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getIsComplete() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getValoration() {
    return of([
      { name: 1, value: 1 },
      { name: 2, value: 2 },
      { name: 3, value: 3 },
      { name: 4, value: 4 },
      { name: 5, value: 5 }
    ]);
  }

  getEvaluationsFiltered(jobId = null, questionnaireTypeIds = null, exercises = null, evaluator = null): any {
    let params: any = {};
    if (jobId) {
      params.jobId = jobId;
    }
    if (questionnaireTypeIds) {
      params.questionnaireTypeIds = questionnaireTypeIds.join(',');
    }
    if (exercises) {
      params.exercises = exercises.join(',');
    }
    if (evaluator) {
      params.evaluator = evaluator;
    }

    return this.http.get(environment.base_URL + "/evaluations", { params }).pipe(map(res => {
      return _.map(res, (q: any) => {
        let totalValoration = 0;
        let totalNumerableQuestions = 0;
        _.forEach(q.answers, (e) => {
          let question = _.get(e, 'question');
          let isNumerable = _.get(question, 'optionQuestion');
          let valoration = _.get(e, 'mumEvaluationValue', 0);
          if (isNumerable) {
            totalNumerableQuestions++;
            totalValoration += valoration;
          }
        })
        q.evaluations = _.sortBy(q.evaluations, (e) => {
          return _.get(e, 'question.nmrOrder');
        });
        q.questionnaire.valoration = totalNumerableQuestions ? (totalValoration / totalNumerableQuestions).toFixed(2) : 0;
        return q;
      })
    }));
  }

  getQuestionnaireById(id): Observable<any> {
    return this.http.get<any>(environment.base_URL + `/questionnaires/${id}`);
  }

  newQuestionnaire(assessment): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + "/questionnaires", assessment);
  }

  newEvaluation(evaluation): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + "/evaluations", evaluation);
  }

  updateQuestionnaire(assessment, id) {
    return this.http.put<any[]>(environment.base_URL + `/questionnaires/${id}`, assessment)
  }

  deleteQuestionnaire(id): Observable<any> {
    return this.http.delete<any>(environment.base_URL + `/questionnaires/${id}`);
  }

}
